import { render, staticRenderFns } from "./vx_select.vue?vue&type=template&id=40f55ccd&"
import script from "./vx_select.vue?vue&type=script&lang=js&"
export * from "./vx_select.vue?vue&type=script&lang=js&"
import style0 from "./vx_select.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oem/work/Rails/tosdere_erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('40f55ccd', component.options)
    } else {
      api.reload('40f55ccd', component.options)
    }
    module.hot.accept("./vx_select.vue?vue&type=template&id=40f55ccd&", function () {
      api.rerender('40f55ccd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/utils/vx_select.vue"
export default component.exports